import DataValidation from './data/DataValidation';
import TrancheData from './data/TrancheData';
import TrancheMetaWrapper from './TrancheMetaWrapper';
import TransactionWrapper from './TransactionWrapper';
class TrancheWrapper {
    data;
    isEditing;
    meta;
    override;
    overrideMap;
    trancheIndex;
    transaction;
    validation;
    constructor({ data, meta, override, overrideMap, trancheIndex, transaction, transactionId, validation }) {
        this.data = data !== undefined ? new TrancheData(data) : undefined;
        this.validation = validation != undefined ? new DataValidation(validation) : undefined;
        this.isEditing = false;
        this.meta = new TrancheMetaWrapper(meta);
        this.override = override !== undefined ? new TrancheData(override) : undefined;
        this.overrideMap = overrideMap;
        this.trancheIndex = trancheIndex;
        this.transaction = new TransactionWrapper(transaction);
        this.transaction.id = transactionId;
    }
    setEditable(flag) {
        const newTranche = new TrancheWrapper(this.toResponse());
        newTranche.isEditing = flag;
        return newTranche;
    }
    removeOverride() {
        const newTranche = new TrancheWrapper(this.toResponse());
        delete newTranche.override;
        newTranche.isEditing = this.isEditing;
        return newTranche;
    }
    removeData() {
        const newTranche = new TrancheWrapper(this.toResponse());
        delete newTranche.data;
        delete newTranche.meta;
        newTranche.isEditing = this.isEditing;
        return newTranche;
    }
    removeOverrideMap() {
        const newTranche = new TrancheWrapper(this.toResponse());
        delete newTranche.overrideMap;
        newTranche.isEditing = this.isEditing;
        return newTranche;
    }
    toResponse() {
        return {
            data: this.data?.toResponse(),
            meta: this.meta?.toResponse(),
            override: this.override?.toResponse(),
            overrideMap: this.overrideMap,
            trancheIndex: this.trancheIndex,
            transaction: this.transaction.toResponse(),
            transactionId: this.transaction.id,
            validation: this.validation?.toResponse()
        };
    }
    basis() {
        return this.override?.basis() ?? this.data?.basis();
    }
    benchmark() {
        return this.override?.benchmark() ?? this.data?.benchmark();
    }
    isTap() {
        return (this.overrideMap?.tap !== undefined && this.overrideMap.tap.toUpperCase() === 'TRUE') || this.data?.tap === true || this.override?.tap === true || this.meta?.tap === true;
    }
    currency() {
        return this.override?.currency() ?? this.data?.currency();
    }
}
export default TrancheWrapper;
